import React from 'react';
import { Link } from 'react-router-dom';

import classes from './UtilsList.module.css';

const UtilsList = ({ props }) => {
    return (
        <div className={classes.UtilsList}>
            {props.map((prop, index) => {
                return (
                    <Link
                        key={index}
                        to={prop.path}
                        className={classes.UtilsItem}
                    >
                        {prop.label}
                    </Link>
                );
            })}
        </div>
    );
};

export default UtilsList;
